/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Pbs_Fb45Inputs */

const en__field_enum_pbs_fb45 = /** @type {(inputs: _Field_Enum_Pbs_Fb45Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F 04 Faculty of Educational Sciences`)
};

const de__field_enum_pbs_fb45 = /** @type {(inputs: _Field_Enum_Pbs_Fb45Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FB 04 Erziehungswissenschaften`)
};

/**
* | output |
* | --- |
* | "F 04 Faculty of Educational Sciences" |
*
* @param {_Field_Enum_Pbs_Fb45Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_pbs_fb45 = /** @type {((inputs?: _Field_Enum_Pbs_Fb45Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Pbs_Fb45Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_pbs_fb45(inputs)
	return de__field_enum_pbs_fb45(inputs)
});
export { _field_enum_pbs_fb45 as "_field_enum_PBS_FB4" }